import { ClientPortfolioPaymentFrequencyEnum } from "web_myplann/Infrastructure/Api/Api";
import type { BuildingSavingsFormInput } from "web_myplann/Portfolio/Forms/BuildingSavingsForm/buildingSavingsFormSchema";

export const BUILDING_SAVINGS_FORM_DEFAULT_VALUES: BuildingSavingsFormInput = {
	name: "",
	contractNumber: "",
	producer: "",
	product: "",
	productCategoryId: null,
	signedAt: null,
	startAt: null,
	endAt: null,
	payment: null,
	paymentFrequency: ClientPortfolioPaymentFrequencyEnum.None,
	appreciation: null,
	stateContribution: null,
	targetAmount: null,
};
